import { supabase } from "@/services/supabase/client";
import { Database } from "@/services/supabase/types";

type DbDailyUserStats = Database["public"]["Tables"]["daily_user_stats"];
export type DailyUserStatsRow = DbDailyUserStats["Row"];
export type DailyUserStatsInsert = DbDailyUserStats["Insert"];
export type DailyUserStatsUpdate = DbDailyUserStats["Update"];

export interface UpdateStreakRes {
  current_streak: number;
  longest_streak: number;
}

export type DailyStatsRes = Pick<
  DailyUserStatsRow,
  "current_streak" | "longest_streak" | "notes_written" | "todos_completed"
>;

async function updateStreak(): Promise<UpdateStreakRes> {
  const { data, error } = await supabase.rpc("update_user_streak");

  if (error) throw error;

  return {
    current_streak: data[0].current_streak,
    longest_streak: data[0].longest_streak,
  };
}

async function getDailyStats(userId: string, date: string): Promise<DailyStatsRes> {
  const { data, error } = await supabase
    .from("daily_user_stats")
    .select("current_streak, longest_streak, notes_written, todos_completed")
    .eq("user_id", userId)
    .eq("date", date)
    .maybeSingle();

  if (error) throw error;

  return {
    current_streak: data?.current_streak ?? 0,
    longest_streak: data?.longest_streak ?? 0,
    notes_written: data?.notes_written ?? 0,
    todos_completed: data?.todos_completed ?? 0,
  };
}

export const dailyUserStatsFetchers = {
  updateStreak,
  getDailyStats,
};
